<script>
  import BaseContentSet from '../BaseContentSet/BaseContentSet.svelte';
  import { getPath } from '../../utils/imageKit.ts';

  let {
    baseContent,
    backgroundImage,
    alignment = 'left',
    lazyloadImage = true,
    reduceImageSize = false,
    containImage = false,
    smallerText = false,
    noMargins = false,
    lang,
    dataTestId = 'marketing-floating-image',
  } = $props();

  const margins = alignment !== 'center' ? 'my-6 md:my-10 lg:my-14' : 'mt-6 md:mt-10 lg:mt-6';

  // Handle Image Setup
  const defaultSrc = getPath(backgroundImage, { w: 398, ar: '3:2' });
  const highResSrc = getPath(backgroundImage, { w: 398, ar: '3:2' }, 2);
  const moDefaultSrc = getPath(backgroundImage, { w: 607, ar: '3:2' });
  const moHighResSrc = getPath(backgroundImage, { w: 607, ar: '3:2' }, 2);
  const smDefaultSrc = getPath(backgroundImage, { w: 360, ar: '3:2' });
  const smHighResSrc = getPath(backgroundImage, { w: 360, ar: '3:2' }, 2);
  const mdDefaultSrc =
    alignment !== 'center'
      ? getPath(backgroundImage, { w: 488, ar: '3:2' })
      : getPath(backgroundImage, { w: 488, ar: '5:3' });
  const mdHighResSrc =
    alignment !== 'center'
      ? getPath(backgroundImage, { w: 488, ar: '3:2' }, 2)
      : getPath(backgroundImage, { w: 488, ar: '5:3' }, 2);
  const lgDefaultSrc =
    alignment !== 'center'
      ? getPath(backgroundImage, { w: 544, ar: '3:2' })
      : getPath(backgroundImage, { w: 544, ar: '5:3' });
  const lgHighResSrc =
    alignment !== 'center'
      ? getPath(backgroundImage, { w: 544, ar: '3:2' }, 2)
      : getPath(backgroundImage, { w: 544, ar: '5:3' }, 2);
</script>

<div data-testid={dataTestId} class="w-full {!noMargins || alignment === 'center' ? margins : ''}">
  <div
    class="grid gap-4 sm:gap-x-6 w-full max-w-6xl mx-auto"
    class:lg:gap-8={alignment !== 'center'}
    class:sm:grid-cols-2={alignment !== 'center'}
    class:lg:grid-cols-1={alignment === 'center'}
    class:lg:px-0={alignment === 'center'}
    class:md:grid-cols-3={reduceImageSize}
  >
    <div class="mx-auto w-full" class:sm:order-1={alignment == 'right'}>
      {#if backgroundImage && backgroundImage.url && backgroundImage.alt}
        <picture>
          <source media="(min-width: 1024px)" srcset={`${lgDefaultSrc}, ${lgHighResSrc} 2x`} />
          <source media="(min-width: 768px)" srcset={`${mdDefaultSrc}, ${mdHighResSrc} 2x`} />
          <source media="(min-width: 640px)" srcset={`${smDefaultSrc}, ${smHighResSrc} 2x`} />
          <source media="(min-width: 431px)" srcset={`${moDefaultSrc}, ${moHighResSrc} 2x`} />
          <source media="(max-width: 430px)" srcset={`${defaultSrc}, ${highResSrc} 2x`} />
          <img
            class={`object-contain w-full h-full max-h-56 sm:max-h-none ${
              backgroundImage.imagePosition ? backgroundImage.imagePosition.replace(/_/g, '-') : 'object-center'
            }`}
            class:sm:max-w-90={alignment === 'center'}
            class:md:max-w-120={alignment === 'center'}
            class:lg:max-w-none={alignment === 'center'}
            class:object-cover={!containImage}
            loading={lazyloadImage === true ? 'lazy' : 'eager'}
            alt={backgroundImage.alt}
            width="280"
            height="186"
            src={defaultSrc}
          />
        </picture>
      {/if}
    </div>
    <BaseContentSet
      {...baseContent}
      lang={lang || 'en'}
      {smallerText}
      className="leading-relaxed md:leading-8 w-full flex flex-col justify-center {reduceImageSize
        ? 'md:col-span-2'
        : ''}"
    />
  </div>
</div>
